import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CareGuideDocumentForm from '../containers/CareGuideDocumentFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideDocumentAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideDocumentAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) =>
        <div>
          <DocumentHead title={t('care_guide_documents_route_add')} />
          <CareGuideDocumentForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideDocumentAddScreen;

Logger.log('silly', `CareGuideDocumentAddScreen loaded.`);
